import { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const readUser = () => {
  try {
    return JSON.parse(localStorage.getItem("userIn"));
  } catch {
    return null;
  }
};

// Per-route role gate. Reads the logged-in user from localStorage into state and re-checks it on
// the `storage` event and a short poll, so clearing the session immediately revokes access instead
// of only on the next full navigation.
const ProtectedRoutes = ({ allowedRoles }) => {
  const location = useLocation();
  const [user, setUser] = useState(readUser);

  useEffect(() => {
    const recheck = () => setUser(readUser());

    const onStorage = (e) => {
      if (e.key === null || e.key === "userIn" || e.key === "login" || e.key === "token") {
        recheck();
      }
    };
    window.addEventListener("storage", onStorage);
    const interval = setInterval(recheck, 2000);

    return () => {
      window.removeEventListener("storage", onStorage);
      clearInterval(interval);
    };
  }, []);

  return user && allowedRoles.includes(user.roles) ? (
    <Outlet />
  ) : (
    <Navigate to="/" state={location.pathname} replace />
  );
};

export default ProtectedRoutes;
